import * as React from 'react';
/**
 *
 * Original name: help
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1259
 *
 */
export const HelpFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M11.75 4C6.535 4 4 6.535 4 11.75s2.535 7.75 7.75 7.75 7.75-2.535 7.75-7.75S16.965 4 11.75 4Zm0 12a.75.75 0 1 1 .75-.75.71.71 0 0 1-.75.75Zm1.246-3.232a.75.75 0 0 0-.496.66v.166a3.01 3.01 0 0 0-1.5 0v-.166a2.245 2.245 0 0 1 1.412-2.043c.145-.061.588-.25.588-1.135C13 9.386 12.616 9 11.755 9a1.237 1.237 0 0 0-.881.366 1.254 1.254 0 0 0-.374.894v.24H9v-.24a2.76 2.76 0 0 1 2.75-2.76h.005a2.55 2.55 0 0 1 2.745 2.75 2.531 2.531 0 0 1-1.504 2.518Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
